import { __assign, __rest } from "tslib";
import React, { createContext, forwardRef, useContext, useMemo } from 'react';
import RcDropdown from 'rc-dropdown';
import { usePrefix } from '../ConfigProvider';
import { useGetPopupContainer } from '../PopupContainerProvider';
import { useValue } from '../utils/hooks';
var autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
// 垂直方向上的默认偏移，单位 px
var defaultOffsetY = 8;
var topOffset = [0, -defaultOffsetY];
var bottomOffset = [0, defaultOffsetY];
var targetOffset = [0, 0];
// 所有支持的 placement 配置
// 在 rc-dropdown 实现的基础上调整了 placement 名 & offset 值，其他保持一致
var placements = {
    topLeft: {
        points: ['bl', 'tl'],
        overflow: autoAdjustOverflow,
        offset: topOffset,
        targetOffset: targetOffset
    },
    top: {
        points: ['bc', 'tc'],
        overflow: autoAdjustOverflow,
        offset: topOffset,
        targetOffset: targetOffset
    },
    topRight: {
        points: ['br', 'tr'],
        overflow: autoAdjustOverflow,
        offset: topOffset,
        targetOffset: targetOffset
    },
    bottomLeft: {
        points: ['tl', 'bl'],
        overflow: autoAdjustOverflow,
        offset: bottomOffset,
        targetOffset: targetOffset
    },
    bottom: {
        points: ['tc', 'bc'],
        overflow: autoAdjustOverflow,
        offset: bottomOffset,
        targetOffset: targetOffset
    },
    bottomRight: {
        points: ['tr', 'br'],
        overflow: autoAdjustOverflow,
        offset: bottomOffset,
        targetOffset: targetOffset
    }
};
var dropdownCtx = createContext(null);
/** 供 `Dropdown` overlay 内容与 `Dropdown` 进行交互，若当前组件未被 `Dropdown` 包裹，函数返回 `null` */
export function useDropdownCtx() {
    return useContext(dropdownCtx);
}
export default forwardRef(function Dropdown(_a, ref) {
    var _b = _a.trigger, trigger = _b === void 0 ? 'hover' : _b, visibleFromProps = _a.visible, onVisibleChange = _a.onVisibleChange, otherProps = __rest(_a, ["trigger", "visible", "onVisibleChange"]);
    var dropdownClassName = usePrefix('dropdown');
    var getPopupContainer = useGetPopupContainer();
    var _c = useValue({
        valueFromProps: visibleFromProps,
        defaultValue: false,
        onChange: onVisibleChange
    }), visible = _c.value, setVisible = _c.setValue;
    var ctrlCtxValue = useMemo(function () { return ({ setVisible: setVisible }); }, [setVisible]);
    return (React.createElement(dropdownCtx.Provider, { value: ctrlCtxValue },
        React.createElement(RcDropdown, __assign({}, otherProps, { visible: visible, onVisibleChange: setVisible, trigger: trigger, getPopupContainer: getPopupContainer, prefixCls: dropdownClassName, placements: placements, ref: ref }))));
});
//# sourceMappingURL=index.js.map